<form [formGroup]="form" class="feature-store__search-form">
    <div class="pull-right">
        <div class="sort-box list-control-widget" style="display: inline-block">
            <span style="display: inline-block;vertical-align:middle;font-size:0;">
                <button class="btn btn--secondary order" [disabled]="disableSortButton()"
                    (click)="form.controls['reverse'].setValue(!form.controls['reverse'].value);"
                >
                    <i class="icon-sort-by-attributes" *ngIf="!reverseOrder()" title="Ascending order"></i>
                    <i class="icon-sort-by-attributes-alt" *ngIf="reverseOrder()" title="Descending order"></i>
                </button>
            </span>
            <dku-bs-select-form-control 
                formControlName="sortBy"
                ngOptions="s.value as s.label for s in list"
                [list]="sortOptions"
                [attr.data-qa-smid]="'sort-order'">
            </dku-bs-select-form-control>
        </div>
    </div>
    
    <div class="std-list-search-box" style="display: inline-block" data-block="search-box">
        <i class="icon icon-remove" [hidden]="!hasSearch()" (click)="resetSearch()" [attr.data-qa-smid]="'close-search-button'"></i>
        <span class="add-on" (click)="selectInput()"> <i class="icon-dku-search"></i></span>
        <input type="search"
            #search
            formControlName="query"
            placeholder="Search&hellip;"
            class="catalog-search-input"
            auto-focus="true"
            [attr.data-qa-smid]="'input-search'"
            />
    </div>
</form>